import Menu from "./Menu";

export default class HeaderFooter {
	public logo: string = "";
	public facebook: string = "";
	public twitter: string = "";
	public instagram: string = "";
	public menu: Array<Menu> = [];
	public footerLogo: string = "";
	public address: string = "";
	public copyRight: string = "";
	public fax: string = "";
	public footerImage: string = "";
	public telephone: string = "";

}